import styled from 'styled-components';
import { Layout } from "antd";
import { white, lightGrey } from "Public/Css/colors";
import { media } from 'Public/Css/media';

export default styled(Layout.Header) `
    background-color: ${ lightGrey };

    height: 64px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 8px 20px;

    text-align: right;
    
    .spacer {
        flex: 1;
    }

    .userInfo {
        background-color: ${ white };
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 4px 8px;
        border-radius: 4px;

        button {
            min-width: 32px;
            height: 32px;
            padding: 4px;
        }
    }

    .userLabel {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        line-height: normal;
    }
    
    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        ${media.mobile`
            display: none;
        `}

        .clock {
            width: 100%;
            justify-content: flex-end;
            align-items: center;
            display: flex;
        }

    }

`;
